import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (sid) {
        try {
          const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
          setUser(data);
        } catch {
          /* ignore */
        }
      }
      window.history.replaceState({}, document.title, "/");
      nav("/scanner");
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-emerald-400 font-mono text-sm pulse-glow" data-testid="auth-callback-status">
        Signing you in…
      </div>
    </div>
  );
}
